<template>
    <div class="indexPage">
        <div class="mainpage">
            <div class="mainbg"></div>
            <div class="page page0">
                <div class="texts">
                    <div class="txt0 t0">油驰电掣 尽在奥迪</div>
                    <div class="txt1 t1">
                        <!-- <div class="showpc">诚邀您莅临<span class="en">2025</span>上海国际车展<span class="en">5.1</span>号馆奥迪展台</div>
                        <div class="showm">诚邀您莅临<span class="en">2025</span>上海国际车展<br /><span class="en">5.1</span>号馆奥迪展台</div> -->
                    </div>
                </div>
            </div>
            <div class="page page1">
                <div class="videopanel">
                    <div class="videobox txt0">
                        <video id="video0" controls="controls" preload="auto" src="../assets/video/video0.mp4" webkit-playsinline="" playsinline="" x5-video-player-type="h5-page" x5-playsinline="" x-webkit-airplay="allow" class="video"></video>
                        <div class="poster" @click="playVideo()">
                            <div class="play"></div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="page page2">
                <div class="txtbox">
                    <div class="txtbox0">
                        <div class="txt0 t0"></div>
                    </div>
                    <div class="txtbox1">
                        <div class="txt1 t1"></div>
                    </div>
                </div>
            </div> -->
            <div class="page page3">
                <div class="pagecon">
                    <div class="bg">
                        <div class="bgmask"></div>
                    </div>
                    <div class="textbox">
                        <div class="texts texts0">
                            <div class="txt0 t0">
                                <div class="showpc zhb">百年奥迪·王者归来<br />奥迪 <span class="en">Q6L e-tron</span> 家族</div>
                                <div class="showm zhb">百年奥迪·王者归来<br />奥迪 <span class="enb">Q6L e-tron</span> 家族</div>
                            </div>
                            <div class="txt1 t1">
                                <div class="showpc">豪华智能电动旗舰 <span class="en">SUV</span></div>
                                <div class="showm">豪华智能电动旗舰 <span class="en">SUV</span></div>
                            </div>
                            <div class="txt2 btn-info" @click="toDetail(0)"><span>了解更多</span></div>
                        </div>
                        <div class="texts texts1">
                            <div class="txt0 t0">智美之上·阔境无双<br />一汽奥迪 <span class="enb">A5L</span></div>
                            <div class="txt1 t1">越级豪华质感新标杆</div>
                            <div class="txt2 btn-info" @click="toDetail(1)"><span>了解更多</span></div>
                        </div>
                        <div class="texts texts2">
                            <div class="txt0 t0">奥迪 <span class="enb">A6L e-tron</span></div>
                            <div class="txt1 t1">豪华 <span class="en">C</span> 级纯电旗舰轿车<br />驭风登场</div>
                            <div class="txt2 btn-info" @click="toDetail(2)"><span>了解更多</span></div>
                        </div>
                        <div class="texts texts3">
                            <div class="txt0 t0">全新奥迪 <span class="enb">Q5L </span></div>
                            <div class="txt1 t1">豪华 <span class="en">B</span> 级 <span class="en">SUV</span> 智能新标杆</div>
                            <div class="txt2 btn-info" @click="toDetail(3)"><span>了解更多</span></div>
                        </div>
                    </div>
                    <div class="swiperbox">
                        <div class="scrollbox">
                            <div class="slide slide0">
                                <div class="point" @click="showDialog(0)">
                                    <div class="point_div"><div class="arrow"></div></div>
                                </div>
                            </div>
                            <div class="slide slide1">
                                <div class="point" @click="showDialog(1)">
                                    <div class="point_div"><div class="arrow"></div></div>
                                </div>
                            </div>
                            <div class="slide slide2">
                                <div class="point" @click="showDialog(2)">
                                    <div class="point_div"><div class="arrow"></div></div>
                                </div>
                            </div>
                            <div class="slide slide3">
                                <div class="point" @click="showDialog(3)">
                                    <div class="point_div"><div class="arrow"></div></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="dialogbox dialogbox0">
            <div class="dialog">
                <div class="close" @click="hideDialog(0)"></div>
                <div class="txt0 leftcon">
                    <div class="lg">
                        <div class="showpc lg0"></div>
                        <div class="showm t0">奥迪 <span class="enb">Q6L e-tron</span> 家族</div>
                    </div>
                    <div class="t1">
                        百年奥迪，王者归来<br />
                        奥迪 <span class="en">Q6L e-tron</span> 家族<br />
                        豪华智能电动旗舰 <span class="en">SUV</span>
                    </div>
                    <div class="btn-info" @click="toDetail(0)">了解更多</div>
                </div>
                <div class="txt1 rightcon">
                    <div class="imgbox imgbox0">
                        <div class="img img0"></div>
                        <div class="imgtxts">
                            <div class="it0">在中国，为中国</div>
                            <div class="it1">
                                搭载华为乾崑技术组合驾驶辅助功能，安全与体验兼得
                            </div>
                        </div>
                    </div>
                    <div class="imgbox imgbox1">
                        <div class="img img1"></div>
                        <div class="imgtxts">
                            <div class="it0">全新“数字舞台”</div>
                            <div class="it1"><span class="en">14.5</span>英寸奥迪 <span class="en">MMI</span>全景显示屏，<span class="en">11.9</span>英寸奥迪虚拟座舱，<span class="en">10.9</span>英寸 <span class="en">MMI</span> 前排乘客显示屏和<br /><span class="en">88</span>英寸 <span class="en">AR-HUD</span> 组成“数字舞台”，带来全面革新的数字体验</div>
                        </div>
                    </div>
                    <div class="imgbox imgbox2">
                        <div class="img img2"></div>
                        <div class="imgtxts">
                            <div class="it0">
                                <div class="showpc"><span class="en">88</span>英寸 <span class="en">AR HUD</span> 覆盖驾驶全场景</div>
                                <div class="showm"><span class="en">88</span>英寸 <span class="en">AR HUD</span> <br />覆盖驾驶全场景</div>
                            </div>
                            <div class="it1">无需低头便可以快速看到导航指令、驾驶辅助系统或音乐等显示，<br />减少“盲驾”风险。</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="dialogbox dialogbox1">
            <div class="dialog">
                <div class="close" @click="hideDialog(1)"></div>
                <div class="txt0 leftcon">
                    <div class="lg">
                        <div class="showpc lg1"></div>
                        <div class="showm t0">一汽奥迪 <span class="enb">A5L</span></div>
                    </div>
                    <div class="t1">
                        智美之上·阔境无双<br />
                        一汽奥迪 <span class="en">A5L</span><br />
                        越级豪华质感新标杆
                    </div>
                    <div class="btn-info" @click="toDetail(1)">了解更多</div>
                </div>
                <div class="txt1 rightcon">
                    <div class="imgbox imgbox0">
                        <div class="img img3"></div>
                        <div class="imgtxts">
                            <div class="it0">数字座舱升维</div>
                            <div class="it1">全新一代智能座舱搭载全新语音助手，配备<span class="en">13.1</span>英寸 <span class="en">W-HUD</span> ，<br />帮助驾驶员清晰了解路况和车辆状态</div>
                        </div>
                    </div>
                    <div class="imgbox imgbox1">
                        <div class="img img4"></div>
                        <div class="imgtxts">
                            <div class="it0">操控无界 智在掌控</div>
                            <div class="it1">
                                含双激光雷达在内的<span class="en">33</span>个传感器融合感知，构建多维度<br />
                                传感网络，可实现城市及高速路段高级组合驾驶辅助
                            </div>
                        </div>
                    </div>
                    <div class="imgbox imgbox2">
                        <div class="img img5"></div>
                        <div class="imgtxts">
                            <div class="it0">纯净座舱 奢华触感</div>
                            <div class="it1">座舱全系标配中国定制带<span class="en">18mm</span> 加厚海绵的云感座椅，搭配后排<span class="en">28°</span>人体工学<br />倾角设计， 以顶级材质与智能舒适配置，打造健康安全与豪华体验兼具的移动<br />生活空间</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="dialogbox dialogbox2">
            <div class="dialog">
                <div class="close" @click="hideDialog(2)"></div>
                <div class="txt0 leftcon">
                    <div class="lg">
                        <div class="showpc lg2"></div>
                        <div class="showm t0">奥迪 <span class="enb">A6L e-tron</span></div>
                    </div>
                    <div class="t1">
                        豪华 <span class="en">C</span> 级纯电旗舰轿车<br />
                        奥迪 <span class="en">A6L e-tron</span><br />
                        驭风登场
                    </div>
                    <div class="btn-info" @click="toDetail(2)">了解更多</div>
                </div>
                <div class="txt1 rightcon">
                    <div class="imgbox imgbox0">
                        <div class="img img6"></div>
                        <div class="imgtxts">
                            <div class="it0">双面人生</div>
                            <div class="it1">
                                基于 <span class="en">PPE</span> 豪华纯电平台打造，性能级电动架构，集成全新 <span class="en">E³1.2</span> 电子电气架构<br />
                                与 <span class="en">800V</span> 高压系统，演绎行政座驾与高性能轿跑的「双面人生」
                            </div>
                        </div>
                    </div>
                    <div class="imgbox imgbox1">
                        <div class="img img7"></div>
                        <div class="imgtxts">
                            <div class="it0">全景智能天幕</div>
                            <div class="it1">
                                <span class="en">9</span>段式智能全景天幕，可实现<span class="en">99.9%</span>紫外线、<span class="en">99.5%</span>以上红外线以及<span class="en">88%</span>能量隔绝，从通透到私<br />密一键切换，科技与仪式感并存 
                            </div>
                        </div>
                    </div>
                    <div class="imgbox imgbox2">
                        <div class="img img8"></div>
                        <div class="imgtxts">
                            <div class="it0">未来之窗</div>
                            <div class="it1">
                                第二代电子外后视镜在雨雪等恶劣天气及暗光环境下能提供清晰视野，<br />
                                显著提升行车安全性
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="dialogbox dialogbox3">
            <div class="dialog">
                <div class="close" @click="hideDialog(3)"></div>
                <div class="txt0 leftcon">
                    <div class="lg">
                        <div class="showpc lg3"></div>
                        <div class="showm t0">全新奥迪 <span class="enb">Q5L</span></div>
                    </div>
                    <div class="t1">
                        <div class="showpc">全新奥迪 <span class="en">Q5L</span><br /></div>
                        豪华 <span class="en">B</span> 级 <span class="en">SUV</span> 智能新标杆
                    </div>
                    <div class="btn-info" @click="toDetail(3)">了解更多</div>
                </div>
                <div class="txt1 rightcon">
                    <div class="imgbox imgbox0">
                        <div class="img img9"></div>
                        <div class="imgtxts">
                            <div class="it0">仿生灵感</div>
                            <div class="it1">前脸横向元素拉伸，营造低趴猎袭姿态</div>
                        </div>
                    </div>
                    <div class="imgbox imgbox1">
                        <div class="img img10"></div>
                        <div class="imgtxts">
                            <div class="it0">兼顾美学与动力</div>
                            <div class="it1">全系标配 <span class="en">MHEVPLUS</span> 混动技术，同级最强 <span class="en">2.0T</span> 动力+全时四驱系统，性能释放</div>
                        </div>
                    </div>
                    <div class="imgbox imgbox2">
                        <div class="img img11"></div>
                        <div class="imgtxts">
                            <div class="it0">极致未来</div>
                            <div class="it1">搭载华为乾崑技术组合驾驶辅助功能，安全与体验兼得</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { sleep, isWeiXin, isIos, getQueryString, isPhoneNumber, calcSize } from '../utils/index'

var lenis = null
var controllerDefault = null
var controllerDefault2 = null
var controllerDefault4 = null
var controllerDefault1 = null
var VM = null
export default {
    components: {},
    data() {
        return {}
    },
    created() {
        VM = this
    },
    mounted() {
        this.bindEvents()
    },
    beforeDestroy() {
        lenis.destroy()
        controllerDefault.destroy()
        controllerDefault1.destroy()
        controllerDefault2.destroy()
        controllerDefault4.destroy()
        TweenMax.killTweensOf('*')
        console.log('清除动画')
    },
    destroyed() {},
    methods: {
        bindEvents() {
            var that = this
            $('#app').scrollTop(0)
            $(window).scrollTop(0)
            controllerDefault = new ScrollMagic.Controller({
                container: $('#app')[0]
            })
            controllerDefault1 = new ScrollMagic.Controller({
                container: $('#app')[0],
                globalSceneOptions: { offset: (-$(window).innerHeight() / 4) * 1 }
            })
            controllerDefault2 = new ScrollMagic.Controller({
                container: $('#app')[0],
                globalSceneOptions: { offset: -$(window).innerHeight() / 2 }
            })
            controllerDefault4 = new ScrollMagic.Controller({
                container: $('#app')[0],
                globalSceneOptions: { offset: (-$(window).innerHeight() / 4) * 3 }
            })
            that.resetPage0()
            that.resetPage1()
            // that.resetPage2()
            that.resetPage3()
            setTimeout(() => {
                that.bindPage0()
                that.bindPage1()
               //  that.bindPage2()
                that.bindPage3()
                setTimeout(() => {
                    that.bindLenis()
                })
            }, 500)
        },
        bindLenis() {
            lenis = new Lenis({
                duration: 2,
                easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
                direction: 'vertical',
                gestureDirection: 'vertical',
                smooth: true,
                mouseMultiplier: 1,
                smoothTouch: false,
                touchMultiplier: 2,
                infinite: false,
                wrapper: $('#app')[0],
                content: $('#app>.indexPage')[0]
            })
            lenis.on('scroll', (e) => {})
            lenis.resize()
            function raf(time) {
                lenis.raf(time)
                requestAnimationFrame(raf)
            }
            requestAnimationFrame(raf)
        },
        resetPage0() {
            for (var i = 0; i <= 1; i++) {
                TweenMax.killTweensOf('.page0 .txt' + i)
                TweenMax.set('.page0 .txt' + i, { opacity: 0, y: 100 })
            }
        },
        bindPage0() {
            var that = this
            this.resetPage0()

            var playAnim = function () {
                for (var i = 0; i <= 1; i++) {
                    TweenMax.to('.page0 .txt' + i, 0.7, { opacity: 1, y: 0, delay: 0.2 * i })
                }
            }
            playAnim()
            if ($(window).width() < 768) {
                new ScrollMagic.Scene({ triggerElement: '.mainbg', triggerHook: 'onLeave', duration: '30%' })
                    .setPin('.mainbg')
                    .addTo(controllerDefault)
                    .on('enter', function () {
                        that.resetPage1()
                        that.resetPage3()
                    })
            } else {
                new ScrollMagic.Scene({ triggerElement: '.mainbg', triggerHook: 'onLeave', duration: '20%' })
                    .setPin('.mainbg')
                    .addTo(controllerDefault)
                    .on('enter', function () {
                        that.resetPage1()
                    })
            }
        },
        resetPage1() {
            for (var i = 0; i <= 1; i++) {
                TweenMax.killTweensOf('.page1 .txt' + i)
                TweenMax.to('.page1 .txt' + i, 0.3, { opacity: 0, y: 100 })
            }
            this.stopVideo()
        },
        bindPage1() {
            var that = this
            this.resetPage1()

            var playAnim = function () {
                for (var i = 0; i <= 1; i++) {
                    TweenMax.to('.page1 .txt' + i, 0.7, { opacity: 1, y: 0, delay: 0.2 * i })
                }
            }
            new ScrollMagic.Scene({ triggerElement: '.page1', triggerHook: 'onLeave', duration: '50%' })
                // .setPin('.page1')
                .addTo(controllerDefault2)
                .on('enter', function () {
                    playAnim()
                    if ($(window).width() <= 768) {
                    } else {
                        that.resetPage3()
                    }
                })
        },
        resetPage2() {
            this.stopVideo()
            for (var i = 0; i <= 1; i++) {
                TweenMax.killTweensOf('.page2 .txt' + i)
                TweenMax.to('.page2 .txt' + i, 0.3, { opacity: 1, y: 200 })
            }
        },
        bindPage2() {
            var that = this
            this.resetPage2()

            var playAnim = function () {
                for (var i = 0; i <= 1; i++) {
                    TweenMax.to('.page2 .txt' + i, 0.7, { opacity: 1, y: 0, delay: 0.2 * i })
                }
            }
            if ($(window).width() <= 768) {
                new ScrollMagic.Scene({ triggerElement: '.page2', triggerHook: 'onLeave', duration: '50%' })
                    // .setPin('.page2')
                    .addTo(controllerDefault2)
                    .on('enter', function () {
                        playAnim()
                        that.resetPage3()
                    })
            } else {
                new ScrollMagic.Scene({ triggerElement: '.page2', triggerHook: 'onLeave', duration: '50%' })
                    // .setPin('.page2')
                    .addTo(controllerDefault1)
                    .on('enter', function () {
                        playAnim()
                        that.resetPage3()
                    })
            }
        },
        resetPage3() {
            this.stopVideo()
            for (var i = 0; i <= 2; i++) {
                TweenMax.killTweensOf('.page3 .txt' + i)
                TweenMax.to('.page3 .txt' + i, 0.3, { opacity: 0, x: -100 })
            }
            TweenMax.set('.page3 .scrollbox', { x: 0 })
            TweenMax.set('.page3 .bg', { x: 0 })
            this.currIdx = -1
            // console.log('reset page3')
        },
        bindPage3() {
            var that = this
            this.resetPage3()

            var anim = new TimelineMax()
            // anim.to('.page3 .texts0', 1, { onStart: play0 })
            // anim.to('.page3 .texts1', 1, { onStart: play1 })
            // anim.to('.page3 .texts2', 1, { onStart: play2 })
            // anim.to('.page3 .texts3', 1, { onStart: play3 })
            anim.to('.page3', 0.3, {}, 0)
            anim.to('.page3 .scrollbox', 3, { x: '-300vw' }, 0.3)
            anim.to('.page3 .bg', 3, { x: '-200vw' }, 0.3)

            var stopAll = function () {
                for (var i = 0; i <= 2; i++) {
                    TweenMax.killTweensOf('.page3 .texts0 .txt' + i)
                    TweenMax.killTweensOf('.page3 .texts1 .txt' + i)
                    TweenMax.killTweensOf('.page3 .texts2 .txt' + i)
                    TweenMax.killTweensOf('.page3 .texts3 .txt' + i)
                }
            }
            that.currIdx = -1
            var play0 = function () {
                console.log('play0')
                if (that.currIdx == 0) return
                that.currIdx = 0
                stopAll()
                for (var i = 0; i <= 2; i++) {
                    TweenMax.to('.page3 .texts0 .txt' + i, 0.7, { opacity: 1, x: 0, delay: 0.2 * i })
                }
                for (var i = 0; i <= 2; i++) {
                    TweenMax.to('.page3 .texts1 .txt' + i, 0.5, { opacity: 0, x: -100, delay: 0.1 * i })
                }
                for (var i = 0; i <= 2; i++) {
                    TweenMax.to('.page3 .texts2 .txt' + i, 0.5, { opacity: 0, x: -100, delay: 0.1 * i })
                }
                for (var i = 0; i <= 2; i++) {
                    TweenMax.to('.page3 .texts3 .txt' + i, 0.5, { opacity: 0, x: -100, delay: 0.1 * i })
                }
            }

            var play1 = function () {
                if (that.currIdx == 1) return
                that.currIdx = 1
                stopAll()
                for (var i = 0; i <= 2; i++) {
                    TweenMax.to('.page3 .texts1 .txt' + i, 0.7, { opacity: 1, x: 0, delay: 0.2 * i })
                }
                for (var i = 0; i <= 2; i++) {
                    TweenMax.to('.page3 .texts0 .txt' + i, 0.5, { opacity: 0, x: -100, delay: 0.1 * i })
                }
                for (var i = 0; i <= 2; i++) {
                    TweenMax.to('.page3 .texts2 .txt' + i, 0.5, { opacity: 0, x: -100, delay: 0.1 * i })
                }
                for (var i = 0; i <= 2; i++) {
                    TweenMax.to('.page3 .texts3 .txt' + i, 0.5, { opacity: 0, x: -100, delay: 0.1 * i })
                }
            }

            var play2 = function () {
                if (that.currIdx == 2) return
                that.currIdx = 2
                stopAll()
                for (var i = 0; i <= 2; i++) {
                    TweenMax.to('.page3 .texts2 .txt' + i, 0.7, { opacity: 1, x: 0, delay: 0.2 * i })
                }
                for (var i = 0; i <= 2; i++) {
                    TweenMax.to('.page3 .texts0 .txt' + i, 0.5, { opacity: 0, x: -100, delay: 0.1 * i })
                }
                for (var i = 0; i <= 2; i++) {
                    TweenMax.to('.page3 .texts1 .txt' + i, 0.5, { opacity: 0, x: -100, delay: 0.1 * i })
                }
                for (var i = 0; i <= 2; i++) {
                    TweenMax.to('.page3 .texts3 .txt' + i, 0.5, { opacity: 0, x: -100, delay: 0.1 * i })
                }
            }

            var play3 = function () {
                if (that.currIdx == 3) return
                that.currIdx = 3
                stopAll()
                for (var i = 0; i <= 2; i++) {
                    TweenMax.to('.page3 .texts3 .txt' + i, 0.7, { opacity: 1, x: 0, delay: 0.2 * i })
                }
                for (var i = 0; i <= 2; i++) {
                    TweenMax.to('.page3 .texts0 .txt' + i, 0.5, { opacity: 0, x: -100, delay: 0.1 * i })
                }
                for (var i = 0; i <= 2; i++) {
                    TweenMax.to('.page3 .texts1 .txt' + i, 0.5, { opacity: 0, x: -100, delay: 0.1 * i })
                }
                for (var i = 0; i <= 2; i++) {
                    TweenMax.to('.page3 .texts2 .txt' + i, 0.5, { opacity: 0, x: -100, delay: 0.1 * i })
                }
            }
            new ScrollMagic.Scene({ triggerElement: '.page3', triggerHook: 'onLeave', duration: '400%' })
                .setPin('.page3')
                .addTo(controllerDefault)
                .setTween(anim)
                .on('enter', function () {
                    // play0()
                })
                .on('progress', function (e) {
                    console.log(e.progress)
                    var progress = e.progress
                    if (e.scrollDirection == 'FORWARD') {
                        if (progress > 0.79) {
                            play3()
                        } else if (progress > 0.42) {
                            play2()
                        } else if (progress > 0.21) {
                            play1()
                        } else {
                            play0()
                        }
                    } else if (e.scrollDirection == 'REVERSE') {
                        if (progress < 0.14) {
                            play0()
                        } else if (progress < 0.3) {
                            play1()
                        } else if (progress < 0.56) {
                            play2()
                        }
                    }
                })
        },
        toDetail(idx) {
            var urls = ['https://www.audi.cn/zh/audi_brand_campaign_landing_page_new/audi_Q6l_e-tron_family.html', 'https://www.audi.cn/zh/audi_brand_campaign_landing_page/Audi_A5L.html', 'https://www.audi.cn/zh/audi_brand_campaign_landing_page_new/audi_a6_L_e-tron.html', 'https://contact.audi.cn/Q5LNF/index.html']
            window.open(urls[idx])
        },
        showDialog(idx) {
            var el = '.dialogbox' + idx
            TweenMax.set(el + ' .txt0', { x: -100, opacity: 0 })
            TweenMax.set(el + ' .txt1', { x: 100, opacity: 0 })
            $(el).fadeIn()
            TweenMax.to(el + ' .txt0', 0.7, { x: 0, opacity: 1, delay: 0.2 })
            TweenMax.to(el + ' .txt1', 0.7, { x: 0, opacity: 1, delay: 0.2 })
        },
        hideDialog(idx) {
            var el = '.dialogbox' + idx
            $(el).fadeOut()
        },
        playVideo() {
            $('.page1 .poster').fadeOut()
            document.getElementById('video0').play()
        },
        stopVideo() {
            $('.page1 .poster').fadeIn()
            try {
                document.getElementById('video0').pause()
            } catch (e) {}
        }
    }
}
</script>

<style scoped lang="scss">
.indexPage {
    position: relative;
    width: 100%;
    font-family: 'audi-wide';
    background-color: #464f56;
    .mainpage {
        width: 100%;
        position: relative;
        // height: 800vh;
        .mainbg {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 600vh;
            z-index: 0;
            background: url(../assets/indexnew/page0_bg.jpg) no-repeat center top;
            background-size: 100% auto;
            @media only screen and (max-width: 768px) {
                background: none;
            }
        }
    }
    * {
        font-family: 'audi-wide';
    }
    .page {
        width: 100vw;
        height: 100vh;
        position: relative;
        left: 0;
        top: 0;
        overflow: hidden;
        pointer-events: all;
        z-index: 3;
    }
    .zhb {
        font-family: 'audi-zh-bold';
    }
    .en {
        font-family: 'AudiTypeGBNormal';
    }
    .enb {
        font-family: 'AudiTypeGBWideBold';
    }
    .showpc {
        display: block;
        @media only screen and (max-width: 768px) {
            display: none;
        }
    }
    .showm {
        display: none;
        @media only screen and (max-width: 768px) {
            display: block;
        }
    }
    .page0 {
        @media only screen and (max-width: 768px) {
            background: #464f56 url(../assets/indexnew/page0_bg_m.jpg) no-repeat left top;
            background-size: 100% auto;
        }
        .texts {
            position: absolute;
            top: 140px;
            left: 140px;
            word-break: keep-all;
            white-space: nowrap;
            word-spacing: normal;
            z-index: 30;
            color: #fff;
            @media only screen and (max-width: 1920px) {
                top: (140vw/19.2);
                left: (140vw/19.2);
            }
            @media only screen and (max-width: 768px) {
                top: (100vw/3.75);
                left: (20vw/3.75);
            }
            .txt0 {
                font-size: 80px;
                line-height: 104px;
                font-family: 'audi-zh-bold';
                opacity: 0;
                @media only screen and (max-width: 1920px) {
                    font-size: (80vw/19.2);
                    line-height: (104vw/19.2);
                }
                @media only screen and (max-width: 768px) {
                    font-size: (34vw/3.75);
                    line-height: (41vw/3.75);
                }
            }
            .txt1 {
                font-size: 28px;
                line-height: 36px;
                margin-top: 8px;
                opacity: 0;
                @media only screen and (max-width: 1920px) {
                    font-size: (28vw/19.2);
                    line-height: (36vw/19.2);
                    margin-top: (8vw/19.2);
                }
                @media only screen and (max-width: 768px) {
                    font-size: (20vw/3.75);
                    line-height: (27vw/3.75);
                    margin-top: (14vw/3.75);
                }
            }
        }
    }

    .page1 {
        @media only screen and (max-width: 768px) {
            height: 30vh;
        }
        .videopanel {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            z-index: 30;
            pointer-events: all;
            @media only screen and (max-width: 768px) {
                top: 0%;
                transform: translate(-50%, -0%);
            }
            .videobox {
                width: 1430px;
                height: 800px;
                @media only screen and (max-width: 1920px) {
                    width: (1430vw/19.2);
                    height: (800vw/19.2);
                }
                @media only screen and (max-width: 768px) {
                    width: 100vw;
                    height: (212vw/3.75);
                }
                .video {
                    width: 100%;
                    height: 100%;
                    object-fit: contain;
                    background-color: #000;
                }
                .poster {
                    width: 100%;
                    height: 100%;
                    background: url(../assets/video/poster0.jpg) no-repeat center center;
                    background-size: cover;
                    position: absolute;
                    left: 0;
                    top: 0;
                    z-index: 40;
                    cursor: pointer;
                    .play {
                        width: 88px;
                        height: 88px;
                        position: absolute;
                        left: 50%;
                        top: 50%;
                        transform: translate(-50%, -50%);
                        background: url(../assets/indexnew/video-play.png) no-repeat center center;
                        background-size: contain;
                        z-index: 4;
                        @media only screen and (max-width: 1920px) {
                            width: (88vw/19.2);
                            height: (88vw/19.2);
                        }
                        @media only screen and (max-width: 768px) {
                            width: (58vw/3.75);
                            height: (58vw/3.75);
                            opacity: 0.6;
                        }
                    }
                }
            }
        }
    }
    .page2 {
        @media only screen and (max-width: 768px) {
            height: 70vh;
        }
        .txtbox {
            width: 100%;
            height: 312px;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            z-index: 10;
            @media only screen and (max-width: 1920px) {
                height: (312vw/19.2);
            }
            @media only screen and (max-width: 768px) {
                height: (96vw/3.75);
            }
            .txtbox0 {
                height: 208px;
                overflow: hidden;
                @media only screen and (max-width: 1920px) {
                    height: (208vw/19.2);
                }
                @media only screen and (max-width: 768px) {
                    height: (55vw/3.75);
                }
                .t0 {
                    width: 100%;
                    height: 100%;
                    background: url(../assets/indexnew/page2_txt0.png) no-repeat center center;
                    background-size: auto 100%;
                }
            }
            .txtbox1 {
                height: 104px;
                overflow: hidden;
                @media only screen and (max-width: 1920px) {
                    height: (104vw/19.2);
                }
                @media only screen and (max-width: 768px) {
                    height: (45vw/3.75);
                }
                .t1 {
                    width: 100%;
                    height: 100%;
                    background: url(../assets/indexnew/page2_txt1.png) no-repeat center center;
                    background-size: auto 100%;
                }
            }
        }
    }
    .page3 {
        overflow-y: visible;
        pointer-events: none;
        .pagecon {
            height: 120vh;
            margin-top: -20vh;

            @media only screen and (max-width: 768px) {
                height: 100vh;
                margin-top: 0vh;
            }
            .bg {
                position: absolute;
                left: 0;
                width: 315.41vw;
                height: 100%;
                background: url(../assets/indexnew/page3_bg3.jpg) no-repeat left top;
                background-size: 100% auto;
                top: 0;
                @media only screen and (max-width: 768px) {
                    width: (3487vw/8.5);
                    height: 100%;
                    background: url(../assets/indexnew/page3_bg3_m.jpg) no-repeat left top;
                    background-size: 100% auto;
                }
            }
            .bgmask {
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
                z-index: 15;
                background: linear-gradient(180deg, rgba(69, 78, 85, 1) 0%, rgba(69, 78, 85, 1) 0%, rgba(69, 78, 85, 0) 50%);
                @media only screen and (max-width: 768px) {
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: 100%;
                    height: 100%;
                    z-index: 15;
                    // background: linear-gradient(180deg, rgba(69, 78, 85, 1) 0%, rgba(69, 78, 85, 1) 1%, rgba(69, 78, 85, 0) 5%);
                }
            }
            .swiperbox {
                width: 100vw;
                height: 100vh;
                position: absolute;
                left: 0;
                bottom: 0;
                z-index: 40;
                .scrollbox {
                    width: 400vw;
                    height: 100%;
                    position: absolute;
                    left: 0;
                    top: 0;
                    .slide {
                        width: 100vw;
                        height: 100vh;
                        position: absolute;
                        left: 0;
                        top: 0;
                        .point {
                            width: (62vw/19.2);
                            height: (62vw/19.2);
                            // background: url(../assets/indexnew/point.png) no-repeat center center;
                            background-size: contain;
                            pointer-events: all;
                            z-index: 20;
                            position: absolute;
                            cursor: pointer;
                            // animation: pointAnim 2s infinite linear;
                            @media only screen and (max-width: 768px) {
                                width: (31vw/3.75);
                                height: (31vw/3.75);
                            }
                        }
                        @keyframes pointAnim {
                            0% {
                                transform: scale(0.8);
                            }
                            50% {
                                transform: scale(1);
                            }
                            100% {
                                transform: scale(0.8);
                            }
                        }
                        &.slide0 {
                            background: url(../assets/indexnew/car1_bg.png) no-repeat left top;
                            background-size: 100% auto;
                            @media only screen and (max-width: 768px) {
                                background: url(../assets/indexnew/car1_bg_m.png) no-repeat left top;
                                background-size: 100% auto;
                            }
                            .point {
                                left: (796vw/19.2);
                                top: (510vw/19.2);
                                @media only screen and (max-width: 768px) {
                                    left: (290vw/3.75);
                                    top: (360vw/3.75);
                                }
                            }
                        }
                        &.slide1 {
                            left: 100vw;
                            background: url(../assets/indexnew/car2_bg.png) no-repeat left top;
                            background-size: 100% auto;
                            @media only screen and (max-width: 768px) {
                                background: url(../assets/indexnew/car2_bg_m.png) no-repeat left top;
                                background-size: 100% auto;
                            }
                            .point {
                                left: (1274vw/19.2);
                                top: (540vw/19.2);
                                @media only screen and (max-width: 768px) {
                                    left: (290vw/3.75);
                                    top: (360vw/3.75);
                                }
                            }
                        }
                        &.slide2 {
                            left: 200vw;
                            background: url(../assets/indexnew/car3_bg.png) no-repeat left top;
                            background-size: 100% auto;
                            @media only screen and (max-width: 768px) {
                                background: url(../assets/indexnew/car3_bg_m.png) no-repeat left top;
                                background-size: 100% auto;
                            }
                            .point {
                                left: (520vw/19.2);
                                top: (570vw/19.2);
                                @media only screen and (max-width: 768px) {
                                    left: (290vw/3.75);
                                    top: (360vw/3.75);
                                }
                            }
                        }
                        &.slide3 {
                            left: 300vw;
                            background: url(../assets/indexnew/car4_bg.png) no-repeat left top;
                            background-size: 100% auto;
                            @media only screen and (max-width: 768px) {
                                background: url(../assets/indexnew/car4_bg_m.png) no-repeat left top;
                                background-size: 100% auto;
                            }
                            .point {
                                top: (524vw/19.2);
                                left: (1373vw/19.2);
                                @media only screen and (max-width: 768px) {
                                    left: (290vw/3.75);
                                    top: (360vw/3.75);
                                }
                            }
                        }
                    }
                }
            }
            .textbox {
                position: absolute;
                left: 0;
                bottom: 0;
                z-index: 50;
                width: 100%;
                height: 100vh;
                pointer-events: none;
                .texts {
                    position: absolute;
                    top: 140px;
                    left: 140px;
                    right: 0;
                    bottom: 0;
                    word-break: keep-all;
                    white-space: nowrap;
                    word-spacing: normal;
                    z-index: 30;
                    color: #fff;
                    @media only screen and (max-width: 1920px) {
                        top: (140vw/19.2);
                        left: (140vw/19.2);
                    }
                    @media only screen and (max-width: 768px) {
                        top: (100vw/3.75);
                        left: (26vw/3.75);
                        color: #fff;
                    }
                    .t0 {
                        font-size: 40px;
                        line-height: 52px;
                        font-family: 'audi-zh-bold';
                        margin-bottom: 16px;
                        @media only screen and (max-width: 1920px) {
                            font-size: (40vw/19.2);
                            line-height: (52vw/19.2);
                            margin-bottom: (16vw/19.2);
                        }
                        @media only screen and (max-width: 768px) {
                            font-size: (28vw/3.75);
                            line-height: (36vw/3.75);
                            margin-bottom: (10vw/3.75);
                        }
                    }
                    .t1 {
                        font-size: 22px;
                        line-height: 33px;
                        margin-bottom: 60px;
                        @media only screen and (max-width: 1920px) {
                            font-size: (22vw/19.2);
                            line-height: (33vw/19.2);
                            margin-bottom: (60vw/19.2);
                        }
                        @media only screen and (max-width: 768px) {
                            font-size: (16vw/3.75);
                            line-height: (27vw/3.75);
                            margin-bottom: (0vw/3.75);
                        }
                    }
                    .btn-info {
                        width: 200px;
                        height: 54px;
                        border: 1px solid #fff;
                        display: flex;
                        flex-direction: row;
                        justify-content: center;
                        align-content: center;
                        align-items: center;
                        font-size: 16px;
                        line-height: 24px;
                        color: #fff;
                        cursor: pointer;
                        pointer-events: all;
                        @media only screen and (max-width: 1920px) {
                            width: (200vw/19.2);
                            height: (54vw/19.2);
                            font-size: (16vw/19.2);
                            line-height: (24vw/19.2);
                        }
                        @media only screen and (max-width: 768px) {
                            width: (180vw/3.75);
                            height: (42vw/3.75);
                            font-size: (14vw/3.75);
                            line-height: (19vw/3.75);
                            position: absolute;
                            right: (97vw/3.75);
                            bottom: (92vw/3.75);
                            color: #fff;
                            border: 1px solid #fff;
                        }
                    }
                }
            }
        }
    }

    .dialogbox {
        width: 100%;
        height: 100vh;
        position: fixed;
        left: 0;
        top: 0;
        z-index: 400;
        background-color: #fff;
        pointer-events: all;
        display: none;
        &.dialogbox0 {
            background: url(../assets/indexnew/slide0_bg.jpg) no-repeat;
            background-size: 100% 100%;
            @media only screen and (max-width: 768px) {
                background: url(../assets/indexnew/slide0_bg_m.jpg) no-repeat;
                background-size: 100% 100%;
            }
        }
        &.dialogbox1 {
            background: url(../assets/indexnew/slide1_bg.jpg) no-repeat;
            background-size: 100% 100%;
            @media only screen and (max-width: 768px) {
                background: url(../assets/indexnew/slide1_bg_m.jpg) no-repeat;
                background-size: 100% 100%;
            }
        }
        &.dialogbox2 {
            background: url(../assets/indexnew/slide2_bg.jpg) no-repeat;
            background-size: 100% 100%;
            @media only screen and (max-width: 768px) {
                background: url(../assets/indexnew/slide2_bg_m.jpg) no-repeat;
                background-size: 100% 100%;
            }
        }
        &.dialogbox3 {
            background: url(../assets/indexnew/slide3_bg.jpg) no-repeat;
            background-size: 100% 100%;
            @media only screen and (max-width: 768px) {
                background: url(../assets/indexnew/slide3_bg_m.jpg) no-repeat;
                background-size: 100% 100%;
            }
        }
        .close {
            position: absolute;
            left: 0px;
            bottom: 0px;
            width: 50px;
            height: 50px;
            z-index: 70;
            background: url(../assets/indexnew/dialog_back.png) no-repeat center center;
            background-size: 100% 100%;
            cursor: pointer;

            @media only screen and (max-width: 768px) {
                width: (25vw/3.75);
                height: (25vw/3.75);
                left: (10vw/3.75);
                bottom: (45vw/3.75);
                background: url(../assets/indexnew/dialog_back2.png) no-repeat center center;
                background-size: 100% 100%;
            }
        }
        .dialog {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            display: flex;
            flex-direction: row;
            justify-content: center;
            color: #fff;
            height: 769px;
            @media only screen and (max-width: 1920px) {
                height: (769vw/19.2);
            }
            @media only screen and (max-width: 768px) {
                height: (660vw/3.75);
                flex-direction: column;
            }
            .leftcon {
                width: 324px;
                margin-right: 80px;
                z-index: 20;
                flex-shrink: 0;
                @media only screen and (max-width: 1920px) {
                    width: (324vw/19.2);
                    margin-right: (80vw/19.2);
                }
                @media only screen and (max-width: 768px) {
                    width: (332vw/3.75);
                    margin-right: (0vw/3.75);
                }
                .lg {
                    width: 324px;
                    height: 303px;
                    margin-bottom: 5px;
                    @media only screen and (max-width: 1920px) {
                        width: (324vw/19.2);
                        height: (303vw/19.2);
                        margin-bottom: (5vw/19.2);
                    }
                    @media only screen and (max-width: 768px) {
                        width: 100%;
                        height: auto;
                        font-size: (28vw/3.75);
                        line-height: (38vw/3.75);
                        font-family: 'audi-zh-bold';
                        text-align: center;
                        margin-bottom: (12vw/3.75);
                    }
                    .lg0 {
                        width: 100%;
                        height: 100%;
                        background: url(../assets/indexnew/dialog_logo0.png) no-repeat left center;
                        background-size: contain;
                    }
                    .lg1 {
                        width: 447px;
                        height: 308px;
                        background: url(../assets/indexnew/dialog_logo1.png) no-repeat left center;
                        background-size: contain;
                        @media only screen and (max-width: 1920px) {
                            width: (447vw/19.2);
                            height: (308vw/19.2);
                        }
                    }
                    .lg2 {
                        width: 100%;
                        height: 100%;
                        background: url(../assets/indexnew/dialog_logo2.png) no-repeat left center;
                        background-size: contain;
                    }
                    .lg3 {
                        width: 460px;
                        height: 308px;
                        background: url(../assets/indexnew/dialog_logo3.png) no-repeat left center;
                        background-size: contain;
                        @media only screen and (max-width: 1920px) {
                            width: (460vw/19.2);
                            height: (308vw/19.2);
                        }
                    }
                }
                .t1 {
                    font-size: 24px;
                    line-height: 36px;
                    margin-bottom: 35px;
                    @media only screen and (max-width: 1920px) {
                        font-size: (24vw/19.2);
                        line-height: (36vw/19.2);
                        margin-bottom: (35vw/19.2);
                    }
                    @media only screen and (max-width: 768px) {
                        font-size: (16vw/3.75);
                        line-height: (24vw/3.75);
                        text-align: center;
                        margin-bottom: (17vw/3.75);
                    }
                }
                .btn-info {
                    width: 200px;
                    height: 54px;
                    border: 1px solid #fff;
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    align-content: center;
                    align-items: center;
                    font-size: 16px;
                    line-height: 24px;
                    cursor: pointer;
                    pointer-events: all;
                    @media only screen and (max-width: 1920px) {
                        width: (200vw/19.2);
                        height: (54vw/19.2);
                        font-size: (16vw/19.2);
                        line-height: (24vw/19.2);
                    }
                    @media only screen and (max-width: 768px) {
                        width: (180vw/3.75);
                        height: (42vw/3.75);
                        font-size: (14vw/3.75);
                        line-height: (19vw/3.75);
                        position: absolute;
                        left: 50%;
                        transform: translateX(-50%);
                        top: (590vw/3.75);
                    }
                }
            }
            .rightcon {
                width: 1211px;
                position: relative;
                left: 0;
                top: 0;
                flex-shrink: 0;
                @media only screen and (max-width: 1920px) {
                    width: (1211vw/19.2);
                }
                @media only screen and (max-width: 768px) {
                    width: (332vw/3.75);
                    height: (434vw/3.75);
                    margin-bottom: (120vw/3.75);
                }
                .imgbox {
                    position: absolute;
                    overflow: hidden;
                    &.imgbox0 {
                        width: 677px;
                        height: 381px;
                        left: 0;
                        top: 0;
                        @media only screen and (max-width: 1920px) {
                            width: (677vw/19.2);
                            height: (381vw/19.2);
                        }
                        @media only screen and (max-width: 768px) {
                            width: 100%;
                            height: (187vw/3.75);
                        }
                    }
                    &.imgbox1 {
                        width: 677px;
                        height: 381px;
                        left: 0;
                        bottom: 0;
                        @media only screen and (max-width: 1920px) {
                            width: (677vw/19.2);
                            height: (381vw/19.2);
                        }
                        @media only screen and (max-width: 768px) {
                            width: (163vw/3.75);
                            height: (241vw/3.75);
                        }
                    }
                    &.imgbox2 {
                        width: 526px;
                        height: 769px;
                        right: 0;
                        top: 0;
                        @media only screen and (max-width: 1920px) {
                            width: (526vw/19.2);
                            height: (769vw/19.2);
                        }
                        @media only screen and (max-width: 768px) {
                            width: (163vw/3.75);
                            height: (241vw/3.75);
                            top: auto;
                            bottom: 0;
                        }
                    }
                    .img {
                        width: 100%;
                        height: 100%;
                        position: absolute;
                        left: 0;
                        top: 0;
                        transition: all 0.5s;
                        transform: scale(1.1);
                        &:hover {
                            transform: scale(1);
                        }
                        &.img0 {
                            background: url(../assets/indexnew/dialog0_img0.jpg) no-repeat center center;
                            background-size: cover;
                            @media only screen and (max-width: 768px) {
                                background: url(../assets/indexnew/dialog0_img0_m.jpg) no-repeat center center;
                                background-size: cover;
                            }
                        }
                        &.img1 {
                            background: url(../assets/indexnew/dialog0_img1.jpg) no-repeat center center;
                            background-size: cover;
                            @media only screen and (max-width: 768px) {
                                background: url(../assets/indexnew/dialog0_img1_m.jpg) no-repeat center center;
                                background-size: cover;
                            }
                        }
                        &.img2 {
                            background: url(../assets/indexnew/dialog0_img2.jpg) no-repeat center center;
                            background-size: cover;
                            @media only screen and (max-width: 768px) {
                                background: url(../assets/indexnew/dialog0_img2_m.jpg) no-repeat center center;
                                background-size: cover;
                            }
                        }

                        &.img3 {
                            background: url(../assets/indexnew/dialog1_img0.jpg) no-repeat center center;
                            background-size: cover;
                            @media only screen and (max-width: 768px) {
                                background: url(../assets/indexnew/dialog1_img0_m.jpg) no-repeat center center;
                                background-size: cover;
                            }
                        }
                        &.img4 {
                            background: url(../assets/indexnew/dialog1_img1.jpg) no-repeat center center;
                            background-size: cover;
                            @media only screen and (max-width: 768px) {
                                background: url(../assets/indexnew/dialog1_img1_m.jpg) no-repeat center center;
                                background-size: cover;
                            }
                        }
                        &.img5 {
                            background: url(../assets/indexnew/dialog1_img2.jpg) no-repeat center center;
                            background-size: cover;
                            @media only screen and (max-width: 768px) {
                                background: url(../assets/indexnew/dialog1_img2_m.jpg) no-repeat center center;
                                background-size: cover;
                            }
                        }

                        &.img6 {
                            background: url(../assets/indexnew/dialog2_img0.jpg) no-repeat center center;
                            background-size: cover;
                            @media only screen and (max-width: 768px) {
                                background: url(../assets/indexnew/dialog2_img0_m.jpg) no-repeat center center;
                                background-size: cover;
                            }
                        }
                        &.img7 {
                            background: url(../assets/indexnew/dialog2_img1.jpg) no-repeat center center;
                            background-size: cover;
                            @media only screen and (max-width: 768px) {
                                background: url(../assets/indexnew/dialog2_img1_m.jpg) no-repeat center center;
                                background-size: cover;
                            }
                        }
                        &.img8 {
                            background: url(../assets/indexnew/dialog2_img2.jpg) no-repeat center center;
                            background-size: cover;
                            @media only screen and (max-width: 768px) {
                                background: url(../assets/indexnew/dialog2_img2_m.jpg) no-repeat center center;
                                background-size: cover;
                            }
                        }

                        &.img9 {
                            background: url(../assets/indexnew/dialog3_img0.jpg) no-repeat center center;
                            background-size: cover;
                            @media only screen and (max-width: 768px) {
                                background: url(../assets/indexnew/dialog3_img0_m.jpg) no-repeat center center;
                                background-size: cover;
                            }
                        }
                        &.img10 {
                            background: url(../assets/indexnew/dialog3_img1.jpg) no-repeat center center;
                            background-size: cover;
                            @media only screen and (max-width: 768px) {
                                background: url(../assets/indexnew/dialog3_img1_m.jpg) no-repeat center center;
                                background-size: cover;
                            }
                        }
                        &.img11 {
                            background: url(../assets/indexnew/dialog3_img2.jpg) no-repeat center center;
                            background-size: cover;
                            @media only screen and (max-width: 768px) {
                                background: url(../assets/indexnew/dialog3_img2_m.jpg) no-repeat center center;
                                background-size: cover;
                            }
                        }
                    }
                    .imgtxts {
                        position: absolute;
                        left: 26px;
                        bottom: 0;
                        z-index: 4;
                        width: 100%;
                        pointer-events: none;
                        @media only screen and (max-width: 1920px) {
                            left: (26vw/19.2);
                        }
                        @media only screen and (max-width: 768px) {
                            left: (10vw/3.75);
                        }
                        .it0 {
                            width: 100%;
                            font-size: 24px;
                            line-height: 36px;
                            margin-bottom: 6px;
                            @media only screen and (max-width: 1920px) {
                                font-size: (24vw/19.2);
                                line-height: (36vw/19.2);
                                margin-bottom: (6vw/19.2);
                            }
                            @media only screen and (max-width: 768px) {
                                font-size: (14vw/3.75);
                                line-height: (21vw/3.75);
                                margin-bottom: (14vw/3.75);
                            }
                        }
                        .it1 {
                            width: 100%;
                            font-size: 14px;
                            line-height: 21px;
                            margin-bottom: 26px;
                            @media only screen and (max-width: 1920px) {
                                font-size: (14vw/19.2);
                                line-height: (21vw/19.2);
                                margin-bottom: (26vw/19.2);
                            }
                            @media only screen and (max-width: 768px) {
                                display: none;
                            }
                        }
                    }
                }
            }
        }
    }
}

.point_div {
    cursor: pointer;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    transform: scale(1);
    border: 1px solid transparent;
    transition: border 300ms;
    &:hover {
        &::before {
            background: #ffffff;
            transform: translate(-50%, -50%) scale(2);
        }
        .arrow {
            opacity: 1;
        }
    }
    .arrow {
        width: 16px;
        height: 16px;
        background: url(../assets/indexnew/arrow.png) no-repeat center center;
        background-size: contain;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 4;
        opacity: 0;
        transition: all 300ms;
    }

    &::before {
        width: 20px;
        height: 20px;
        content: ' ';
        display: block;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        transition: transform 300ms, background 300ms;
        border-radius: 50%;
        box-sizing: border-box;
        border: 2px solid transparent;
        border-color: #ffffff;
    }
    &::after {
        content: ' ';
        position: absolute;
        display: block;
        top: 50%;
        left: 50%;
        width: 20px;
        height: 20px;
        margin-top: -10px;
        margin-left: -10px;
        transform-origin: center;
        border-radius: 50%;
        box-sizing: border-box;
        animation: point_anim 4s infinite;
        border: 2px solid #fff;
    }
}
@keyframes point_anim {
    0% {
        opacity: 0;
        border-width: 2px;
        transform: scale(0.5, 0.5);
        background-color: rgba(255, 255, 255, 0.5);
    }
    50% {
        opacity: 1;
        transform: scale(1, 1);
        border-width: 2px;
        background-color: rgba(255, 255, 255, 0.5);
    }
    100% {
        opacity: 0;
        border-width: 1px;
        background-color: transparent;
        transform: scale(2, 2);
    }
}
</style>
